module.exports = __webpack_public_path__ + "static/img/logo-white.b7ebd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.png
// module id = YyoC
// module chunks = 8